import React from 'react';
import useStyles from './CardStyles';
var Card = function (_a) {
    var className = _a.className, children = _a.children;
    var styles = useStyles();
    return React.createElement("article", { className: styles.card + " " + className }, children);
};
Card.defaultProps = {
    className: '',
};
export default Card;
